import AppVersionNotifier from "./AppVersionNotifier"
export default AppVersionNotifier



// WEBPACK FOOTER //
// ./src/index.js